import actionTypes from './actionTypes';
import api from 'src/utils/api';
import { setAlert } from 'src/modules/shared/alert/actions';
import { closeModal }  from 'src/modules/shared/modal/actions';
import * as log from 'loglevel';

export const followCommunity = (community, userId, successMessage, silent = false) => {
  return async (dispatch) => {
    dispatch({ type: actionTypes.FOLLOW_COMMUNITY });
    try {
      const response = await api.auroraPost('user-group-subscriptions', {
        userId,
        groupId: community.communityId,
      });
      const { data: { status } } = response;

      if (!!status && !status.success) {
        if (!silent) {
          dispatch(setAlert(status.message));
        }
        return dispatch({ type: actionTypes.FOLLOW_COMMUNITY_FAILURE, error: status });
      }

      if (!silent && successMessage) {
        dispatch(setAlert(successMessage, 'success'));
      }
      return dispatch({
        type: actionTypes.FOLLOW_COMMUNITY_SUCCESS,
        community,
      });
    } catch (ex) {
      log.error(ex);
      dispatch(setAlert(ex.message));
      return dispatch({ type: actionTypes.FOLLOW_COMMUNITY_FAILURE, error: ex });
    }
  };
};

export const unfollowCommunity = (community, userId, successMessage) => {
  return async (dispatch) => {
    dispatch({ type: actionTypes.UNFOLLOW_COMMUNITY });
    try {
      const response = await api.auroraDel('user-group-subscriptions', {
        params: {
          userId,
          groupId: community.communityId,
        },
      });
      const { data: { status } } = response;

      if (!!status && !status.success) {
        dispatch({ type: actionTypes.UNFOLLOW_COMMUNITY_FAILURE, error: status });
        dispatch(setAlert(status.message));
        return;
      }

      dispatch({
        type: actionTypes.UNFOLLOW_COMMUNITY_SUCCESS,
        communityId: community.communityId,
        slug: community.slug,
      });
      dispatch(closeModal());
      dispatch(setAlert(successMessage, 'success'));
    } catch (ex) {
      log.error(ex);
      dispatch({ type: actionTypes.UNFOLLOW_COMMUNITY_FAILURE, error: ex });
      dispatch(setAlert(ex.message));
    }
  };
};



// WEBPACK FOOTER //
// ./src/modules/community/shared/actions.js